export default "__VITE_ASSET__ed53f698__"